import {combineReducers} from 'redux';
import isLoaderCountReducer from "../shared/reducers/setting"
import settingReducer from "../shared/reducers/setting"
import serviceListReducer from "./service"
import dashboardReducer from "./dashboard"

const rootReducer = combineReducers({
  setting: settingReducer,
  isLoaderCount: isLoaderCountReducer,
  serviceList: serviceListReducer,
  dashboardList: dashboardReducer,

});

export default rootReducer;